// Browser-safe schema-only exports
// This file exports ONLY schemas without any Node.js dependencies
export { settings, mapping, firehose } from './firehose/schemas';
